export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1456,
};

export const ANIMATION_CLASSES = {
  animating: 'animating',
  animated: 'animated',
  rigged: 'animation-rigged',
  noTransitions: 'animate-no-transitions',
};

export const CUSTOM_EVENTS = {
  scrolledTo: 'scrolled-to',
};

export const URL_SEARCH_FILTERS = 'filters';
export const URL_SEARCH_SEARCH = 'q';

export const API_ENDPOINTS = {
  optiForms: 'api/episerver/v3.0/content',
  dynamicsForms: 'tmfapi/GetDynamicFormData',
};
